import { fetchIncludeProductsList } from '@/services';
import { fetchProductActivitiesFindAll } from '@/services/apis/activity';
import { _PromotionType, DiscountType, type AnyObj, type AnyObjOrNull } from '@/types';
import { defineStore } from 'pinia';

interface State {
  /** 适用商品数据 */
  suitCommodityList: AnyObj[];
  /* 商品对应的所有活动信息数据 */
  commodityAllActivities: AnyObj[];
  /* 第x件x折活动信息数据 */
  discountActivityDetail: AnyObjOrNull;
  /** 满减送活动数据 */
  fulfilPresentData: AnyObjOrNull;
}

export const useActivityStore = defineStore('activity', {
  state: (): State => ({
    suitCommodityList: [],
    commodityAllActivities: [],
    discountActivityDetail: null,
    fulfilPresentData: null,
  }),

  getters: {
    // 适用商品数据中 判断是否存在上架且有货的商品 若为false则相当于活动已经进行不下去了
    isSuitCommodityListAvailabe(state) {
      if (state.suitCommodityList?.length) {
        return !!state.suitCommodityList.find((prod: AnyObj) => {
          return prod.enabled;
        });
      } else {
        return false;
      }
    },
    // 全部商品已经售罄
    isCommodityListSoldOut(state) {
      if (state.suitCommodityList?.length) {
        const isNoStockLength = state.suitCommodityList.filter((prod: AnyObj) => {
          return prod.variants.every((item: AnyObj) => !item.isThereAnyStock);
        });
        if (isNoStockLength?.length === state.suitCommodityList.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // // 商品同时是已下架和售罄，优先下架
    // isFullWithSoldOutAndSelf(state){
    //   if (state.suitCommodityList?.length) {
    //     const self = state.suitCommodityList.filter((prod: AnyObj) => {
    //       prod.enabled;
    //     })?.length;
    //     const isSoldOutLength = state.suitCommodityList.filter((prod: AnyObj) => {
    //       prod.variants.every((item: AnyObj) => !item.isThereAnyStock);
    //     })?.length;
    //     if (self == isSoldOutLength) {
    //       return true;
    //     }
    //   } else {
    //     return false;
    //   }
    // }
  },

  actions: {
    async getSuitCommodityList(isSuit?: boolean, ids?: string[], take = 50) {
      const data = await fetchIncludeProductsList(isSuit, ids, take);
      if (data) this.suitCommodityList = data;
      return this.suitCommodityList;
    },
    async getProductAllActivities(productId: string, refresh?: boolean) {
      if (!this.commodityAllActivities.length || refresh) {
        const data = await fetchProductActivitiesFindAll(productId);
        if (data) {
          this.commodityAllActivities = processActivitiesDataHandler(data);
          console.log(`this.commodityAllActivities`, this.commodityAllActivities);
        }
      }
      return this.commodityAllActivities;
    },
  },
});

/**
 * 处理活动数据
 * @param originalData - 原始活动数据
 * @returns 处理后的活动数据
 */
function processActivitiesDataHandler(originalData: any[]) {
  return originalData.flatMap((item) => {
    if (item.__typename !== _PromotionType.FullDiscountPresent) return [item];

    const [baseRules, cloneRules] = item.ruleValues.reduce(
      (
        [base, clone]: any,
        rule: { discountValue: { discountType: string }; freeGiftValues: string | any[] }
      ) => {
        const isNoDiscount = rule.discountValue.discountType === DiscountType.noDiscount;
        const hasGifts = rule.freeGiftValues?.length > 0;

        // 原始noDiscount 或 有赠品
        if (isNoDiscount || (!isNoDiscount && hasGifts)) {
          clone.push({
            ...JSON.parse(JSON.stringify(rule)),
            discountValue: !isNoDiscount
              ? { ...rule.discountValue, discountType: 'noDiscount', discount: 0 }
              : rule.discountValue,
          });
        }

        // 保留到原对象（排除noDiscount）
        if (!isNoDiscount) {
          base.push(rule);
        }

        return [base, clone];
      },
      [[], []]
    );

    const result = [];

    // 保留处理后的原对象
    if (baseRules.length > 0) {
      result.push({ ...item, ruleValues: baseRules });
    }

    if (cloneRules.length > 0) {
      result.push({
        ...item,
        ruleValues: cloneRules,
        clonedFrom: item.id,
      });
    }

    return result.length > 0 ? result : [item];
  }, []);
}
